export default __webpack_public_path__ + "static/media/BBQ.6f7d0b5c.jpg";